import styled from 'styled-components';
import { fontAccent, fontBody } from 'Styles/fonts';

export const Heading = styled.h2`
  ${fontAccent(18)};
  margin: 0;
`;

export const Subtitle = styled.p`
  ${fontBody(16)};
  margin: 0;
`;

export const CardContainer = styled.div`
  margin-top: 16px;

  & > *:not(:last-child) {
    margin-bottom: 16px;
  }
`;
